import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="container-wide py-24">
        <div className="h-4 w-48 bg-[#F5F5F5] animate-pulse" />
        <div className="h-4 w-72 bg-[#F5F5F5] animate-pulse mt-3" />
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }
  return children;
}
